"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsFields = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_table_field_1 = require("../../../composite/form/fields/form-table-field");
const selector_1 = require("../../../composite/form/selectors/selector");
const internal_settings_columns_1 = require("./internal-settings-columns");
const internal_settings_dialog_1 = require("./internal-settings-dialog");
exports.SettingsFields = () => {
    const settingGroups = selector_1.useFormSelector((data) => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.settingGroups) !== null && _a !== void 0 ? _a : []; });
    return (react_1.default.createElement(react_1.default.Fragment, null, (settingGroups !== null && settingGroups !== void 0 ? settingGroups : []).map((group, idx) => (react_1.default.createElement(SettingsGroup, { key: group.name, group: group, idx: idx })))));
};
const SettingsGroup = ({ group, idx, }) => {
    const collectionDatakey = `settingGroups[${idx}].settings`;
    const columns = internal_settings_columns_1.useColumns(collectionDatakey);
    const MemoizedTable = react_1.useMemo(() => function Table() {
        return (react_1.default.createElement(form_table_field_1.FormTableField, { name: collectionDatakey, labelOptions: { hide: true }, visibleAdd: false, layoutOptions: { noSpacing: true }, columns: columns, FormFieldsComponent: internal_settings_dialog_1.InternalSettingsDialog, disabled: false, showRadioCond: lodash_1.stubTrue, visibleRemove: false }));
    }, []);
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: `${group.name} - ${group.description}` },
        react_1.default.createElement(MemoizedTable, null)));
};
//# sourceMappingURL=internal-settings-fields.js.map